import { MenuType, RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
    { path: '/dashboard', title: 'Wire Size calculator', menuType: MenuType.LEFT, icon: 'pe-7s-graph' },
    { path: '/user', title: 'User profile', menuType: MenuType.LEFT, icon:'pe-7s-user' },
    { path: '/quicksearch', title: 'Quick search', menuType: MenuType.LEFT, icon:'pe-7s-search' }
];



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar-routes.config.ts